import angular from "angular"

import client from "@/client.js"
import Auth from "@/auth.js"

/**
 * Main service to control the authentication of the user.
 */
const factory = [
  "$rootScope",
  "store",
  "$state",
  "$http",
  "apiService",
  function($rootScope, store, $state, $http, apiService) {
    /**
     * Shows an Auth0 popup to login a user. If the user is correctly
     * logged in, his profile and token returned by Auth0 is stored using
     * localStorage.
     */
    var api_auth_url = apiService.api_auth_url

    $rootScope.$on("unauthenticated", function() {
      console.log("$on:unauthenticated")
      // store.remove('token');
      logout()
    })

    /**
     * Re-applies the stored JWT to $http defaults when the app boots.
     * Memory is cleared on refresh, so without this REST calls miss Authorization
     * when the API hostname is not in jwtInterceptor whiteListedDomains.
     */
    function restoreSession() {
      applyTokenToHttp(getToken())
    }

    function applyTokenToHttp(token) {
      $http.defaults.headers.common.Authorization = token ? "JWT " + token : ""
    }

    function goAfterLogin() {
      try {
        var role = store.get("user").rol
        switch (role) {
          case "EDITOR ATENCIONES MASIVAS":
            $state.go("app.estudiantes")
            break
          default:
            $state.go("app.home")
            break
        }
      } catch (err) {
        console.log(err)
        $state.go("app.home")
      }
    }

    function login(username, password, callback) {
      $http({
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        url: apiService.baseUrl + api_auth_url,
        data: JSON.stringify({ username: username, password: password })
      })
        .then(function(response) {
          var token = response.data.token
          store.set("user", response.data.user)
          store.set("token", token)
          applyTokenToHttp(token)
          goAfterLogin()
        })
        .catch(function() {
          console.log("an error...")
          callback()
        })
    }

    /**
     * Removes token and profile information from localStorage and redirects to
     * the home.
     */
    function logout() {
      store.remove("user")
      store.remove("token")
      store.remove("periodo_activo")
      applyTokenToHttp(null)

      Auth.onLogout()

      client.resetStore()

      $state.go("login")
    }

    /**
     * Obtains the token of the user logged in.
     * @return {string} User token.
     */
    function getToken() {
      return store.get("token")
    }

    function getUser() {
      var user = store.get("user")
      if (!user) {
        logout()
        return
      }
      var temp = user.full_name

      return temp.trim() === "" ? user.username : temp
    }

    return {
      login: login,
      logout: logout,
      getToken: getToken,
      getUser: getUser,
      restoreSession: restoreSession
    }
  }
]

angular.module("appModule").factory("loginService", factory)
